import React, { useState, useEffect } from 'react';
import { FaSave, FaUserGraduate, FaFileInvoice } from 'react-icons/fa';
import { fetchAPI } from '../../utils/api';

export default function AdminMarks() {
    const [students, setStudents] = useState([]);
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        user_id: '',
        class_id: '',
        exam_name: '',
        marks: ''
    });

    const loadData = async () => {
        try {
            const [studentsData, classesData] = await Promise.all([
                fetchAPI('/admin/get_students_for_marks.php'),
                fetchAPI('/admin/get_classes.php')
            ]);
            setStudents(studentsData);
            setClasses(classesData);
        } catch (err) {
            console.error("Failed to load data", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await fetchAPI('/admin/save_marks.php', {
                method: 'POST',
                body: JSON.stringify(formData)
            });
            alert('Marks saved successfully!');
            setFormData({ ...formData, marks: '' }); // Clear marks only
        } catch (err) {
            alert("Error: " + err.message);
        }
    };

    if (loading) return <div className="p-8 text-center text-gray-500 font-bold">Loading students and classes...</div>;

    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 lemon-milk">Upload Results</h2>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Student</label>
                            <select
                                name="user_id"
                                value={formData.user_id}
                                onChange={handleChange}
                                className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            >
                                <option value="">Select Student</option>
                                {students.map(s => <option key={s.id} value={s.id}>{s.name} ({s.email})</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Class</label>
                            <select
                                name="class_id"
                                value={formData.class_id}
                                onChange={handleChange}
                                className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            >
                                <option value="">Select Class</option>
                                {classes.map(c => <option key={c.id} value={c.id}>{c.name} (Grade {c.grade})</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Exam Name / Date</label>
                            <input
                                name="exam_name"
                                value={formData.exam_name}
                                onChange={handleChange}
                                placeholder="Unit Test 01 - Integration"
                                className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Marks</label>
                            <input
                                type="number"
                                name="marks"
                                value={formData.marks}
                                onChange={handleChange}
                                placeholder="85"
                                className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                    </div>

                    <div className="pt-6 border-t flex justify-end">
                        <button
                            type="submit"
                            className="px-12 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 shadow-xl shadow-blue-100 flex items-center gap-2 transition-all active:scale-95"
                        >
                            <FaSave /> SAVE RESULTS
                        </button>
                    </div>
                </form>
            </div>

            {/* Quick Tips */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-4 rounded-xl flex items-start gap-4 text-blue-800">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <FaUserGraduate size={18} />
                    </div>
                    <div>
                        <h4 className="font-bold text-sm">Select Student First</h4>
                        <p className="text-xs opacity-80 mt-1">Make sure you have selected the correct student from the dropdown list before entering marks.</p>
                    </div>
                </div>
                <div className="bg-purple-50 p-4 rounded-xl flex items-start gap-4 text-purple-800">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <FaFileInvoice size={18} />
                    </div>
                    <div>
                        <h4 className="font-bold text-sm">Class Context</h4>
                        <p className="text-xs opacity-80 mt-1">Marks are tied to a specific class. This will show up in the student's personal "My Results" tab.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
